const Highlight = ({ children }) => {
    return (
      <span className="text-white bg-black px-2 py-0.5 rounded-md whitespace-nowrap">
        {children}
      </span>
    );
};

export default Highlight;